import React from 'react';

export const Paragraph = ({ children, ...props }) => (
  <p {...props}>{children}</p>
);
